<div class="td-wb-input-group-note__message">
  <ng-content />
</div>
